import { BaseType } from "../base/base-type";
import { cleanUndefinedOrEmpty } from "../..";
import { ReservedApplicantIdHelper } from "../procedure/form-schema/applicant-schema/applicant-reserved-ids";
import {
  ApplicantSchemaKeys,
  DefaultApplicantSchemaKeys,
} from "../procedure/procedure-detail";
import { FormData } from "@graffer-inc/form-schema";

export const ApplicantTypeLiteralList = [
  "INDIVIDUAL",
  "CORPORATE",
  "UNINCORPORATED_GROUP",
] as const;

export type ApplicantTypeLiterals = (typeof ApplicantTypeLiteralList)[number];

export class ApplicantTypeState extends BaseType<ApplicantTypeLiterals> {}

export type Applicant = {
  type: ApplicantTypeLiterals;
  name: string;
  nameKana: string;
  postalCode?: string;
  address: string;

  birthDate?: string;
  tradeName?: string;
  tradeNameKana?: string;

  corporateNumber?: string;
  representativeName?: string;

  tel?: string;
  email: string;
  contactPersonal?: string;
};

/**
 * @deprecated
 * use convertToJsonDocumentWithApplicantSchemaKeys instead
 *
 * 申請者項目のうち空文字、undefinedのvalueを持つentryをomitする
 */
export function convertToJsonDocument(formData: FormData): FormData {
  return convertToJsonDocumentWithApplicantSchemaKeys(
    formData,
    DefaultApplicantSchemaKeys,
  );
}

export const convertToJsonDocumentWithApplicantSchemaKeys = (
  formData: FormData,
  applicantSchemaKeys: ApplicantSchemaKeys,
): FormData => {
  return Object.keys(formData).reduce((prevV, curV) => {
    if (ReservedApplicantIdHelper.contains(curV, applicantSchemaKeys)) {
      const val = formData[curV];
      if (!val) {
        return {
          ...prevV,
        };
      }
    }

    return {
      ...prevV,
      [curV]: formData[curV],
    };
  }, {});
};

/**
 * @deprecated
 * 申請者の予約された値以外のDocumentに変換する
 *
 * ApplicationContent.filteredDocument からのみ参照される。
 * 過去の個別プランでの利用のみを前提としている。
 * 利用範囲を増やさないこと。
 */
export function convertToFilteredDocument(formData: FormData): FormData {
  return Object.keys(formData).reduce((prevV, curV) => {
    if (!ReservedApplicantIdHelper.contains(curV, DefaultApplicantSchemaKeys)) {
      return {
        ...prevV,
        [curV]: formData[curV],
      };
    }
    return {
      ...prevV,
    };
  }, {});
}

/**
 * @deprecated
 * use convertToJsonDocumentWithApplicantSchemaKeys instead
 *
 * FormDataから申請者モデルに変換する
 */
export function convertFormDataToApplicant(formData: FormData): Applicant {
  return convertFormDataToApplicantWithApplicantSchemaKeys(
    formData,
    DefaultApplicantSchemaKeys,
  );
}

export const convertFormDataToApplicantWithApplicantSchemaKeys = (
  formData: FormData,
  applicantSchemaKeys: ApplicantSchemaKeys,
): Applicant => {
  return cleanUndefinedOrEmpty({
    type: formData[applicantSchemaKeys.applicantType.id],
    name: formData[applicantSchemaKeys.applicantName.id],
    nameKana: formData[applicantSchemaKeys.applicantNameKana.id],
    postalCode: formData[applicantSchemaKeys.applicantPostalCode.id],
    address: formData[applicantSchemaKeys.applicantAddress.id],
    birthDate: formData[applicantSchemaKeys.applicantBirthDate.id],
    tradeName: formData[applicantSchemaKeys.applicantTradeName.id],
    tradeNameKana: formData[applicantSchemaKeys.applicantTradeNameKana.id],
    corporateNumber: formData[applicantSchemaKeys.applicantCorporateNumber.id],
    representativeName:
      formData[applicantSchemaKeys.applicantRepresentativeName.id],
    tel: formData[applicantSchemaKeys.applicantPhoneNumber.id],
    email: formData[applicantSchemaKeys.applicantEmail.id],
    contactPersonal: formData[applicantSchemaKeys.applicantContactPersonal.id],
  }) as Applicant;
};
